/**
 * TanStack Query hooks for `campaign-spillover`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	campaignSpilloverQueryKeys,
	type CreateCampaignSpilloverBody,
	type ListCampaignSpilloverResponse,
	type CampaignSpilloverRow,
} from "./api";

export function useCampaignSpilloverList(): UseQueryResult<ListCampaignSpilloverResponse, Error> {
	return useQuery({
		queryKey: campaignSpilloverQueryKeys.list(),
		queryFn: list,
	});
}

export function useCampaignSpilloverCreate(): UseMutationResult<CampaignSpilloverRow, Error, CreateCampaignSpilloverBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: campaignSpilloverQueryKeys.all });
		},
	});
}

export function useCampaignSpilloverDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: campaignSpilloverQueryKeys.all });
		},
	});
}
